import { render, staticRenderFns } from "./SendToTab.vue?vue&type=template&id=686323c4&scoped=true&"
import script from "./SendToTab.vue?vue&type=script&lang=js&"
export * from "./SendToTab.vue?vue&type=script&lang=js&"
import style0 from "./SendToTab.vue?vue&type=style&index=0&id=686323c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686323c4",
  null
  
)

export default component.exports